export default class Fetch {
  static async get(url) {
    return fetch(url);
  }

  static async post(url, body = {}) {
    return await fetch(url, {
      body: JSON.stringify(body),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "POST",
    });
  }

  static async patch(url, body = {}) {
    return await fetch(url, {
      body: JSON.stringify(body),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "PATCH",
    });
  }

  static async put(url, body = {}) {
    return fetch(url, {
      body: JSON.stringify(body),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "PUT",
    });
  }

  static async delete(url, body = {}) {
    return fetch(url, {
      body: JSON.stringify(body),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "DELETE",
    });
  }
}
